import { createReducer, on } from '@ngrx/store';
import { ApplicationsApiActions } from './scheduled-applications.actions';
import { adapter, initialState } from './scheduled-applications.state';

export const scheduledApplicationsReducer = createReducer(
  initialState,
  on(ApplicationsApiActions.scheduledApplicationsLoaded, (state, { applications }) =>
    adapter.setAll(applications, state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectScheduledApplicationIds = selectIds;

export const selectScheduledApplicationEntities = selectEntities;

export const selectAllScheduledApplications = selectAll;
